import xd10ii from './devices/xd10ii';
import xd42iii from './devices/xd42iii';
import xd38iii from './devices/xd38iii';
import xd20iii from './devices/xd20iii';
import xe20 from './devices/xe20';
import xdi32 from './devices/xdi32';
import xm20 from './devices/xm20';

// Register a new machine here. List cards, routes and translations use this list.
export const equipmentRegistry = Object.freeze([xd10ii, xd20iii, xd38iii, xd42iii, xe20, xm20, xdi32]);

const ids = new Set();
const paths = new Set();
for (const equipment of equipmentRegistry) {
  if (ids.has(equipment.id) || paths.has(equipment.path)) {
    throw new Error(`Duplicate equipment id or path: ${equipment.id}`);
  }
  ids.add(equipment.id);
  paths.add(equipment.path);
}

export const equipmentResources = {};
for (const equipment of equipmentRegistry) {
  for (const [language, resource] of Object.entries(equipment.translations)) {
    equipmentResources[language] ||= {};
    equipmentResources[language][equipment.id] = resource;
  }
}
